import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[ngbTabContent]'
})
export class NgbTabContentDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}


@Directive({
  selector: '[ngbTabTitle]'
})
export class NgbTabTitleDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}